import React, { memo, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setTitle } from "@store/title-store";
import { TitleProps } from "@store/title-store";
import { EditRequestTraining } from "@feature/request-training/edit-request-training";

const EditRequestTrainingPage: React.FC = memo(() => {
  const { pathname } = useLocation();
  const [titleChild, setTitleChild] = useState<string>();

  useEffect(() => {
    const title = [
      { title: "Главная", href: "/" },
      { title: "Заявки на обучение", href: "/control-request-training" },
    ] as TitleProps[];

    const id = pathname
      .split("/")
      .filter((e) => parseInt(e))
      .shift();
    if (!id) setTitleChild(undefined);
    if (id && titleChild) title.push({ title: titleChild, href: pathname });

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleChild]);

  return (
    <>
      <main className="content-container">
        <div className="content-section">
          {/* <div className="top-content">
            <BreadCrumb items={["Главная", "Заявки на обучение"]} />
            <Title text="Заявки на обучение" />
          </div> */}
          <EditRequestTraining setTitle={setTitleChild} />
        </div>
      </main>
    </>
  );
});

export default EditRequestTrainingPage;
